module.exports = "<div>\n    <div class=\"loginPageMessagesContent\">\n        <div id=\"loginResultMessage\" class=\"loginPageMessage\"></div>\n    </div>\n    <div class=\"field_container\">\n        <button id=\"footerBtnLoginMsgPage\" class=\"btnTouch btnTouch-prim\" type=\"submit\" data-theme=\"b\" data-i18n=\"common::login.returnToLogInPage\"></button>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// /jenkins/workspace/CudaLaunch_release_production/~/html-loader!./logon/logon_message_view_content.html
// module id = 43
// module chunks = 0 3